import React from "react";
import VerifiedCompetencyLIst from "../../features/VerifiedCompetency/VerifiedCompetencyList";

const VerifiedCompetency = () => {
  return (
    <>
      <VerifiedCompetencyLIst />
    </>
  );
};

export default VerifiedCompetency;
